import Drawer from '@mui/material/Drawer'

import { ReactComponent as SmartFarmLogo } from '../../assets/smart_farm_logo.svg'

import { Box } from '@mui/material'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { useEffect, useMemo } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { fetchPermissions, selectPermissions } from '../../store/authSlice'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { COLORS } from '../../styles/colors'
import { fontTheme } from '../../styles/font'

import SidebarMainMenu from './components/SidebarMainMenu/SidebarMainMenu'
import SidebarSettings from './components/SidebarSettings/SidebarSettings'

const drawerTheme = createTheme({
	...fontTheme,
	components: {
		...fontTheme.components,
		MuiDrawer: {
			styleOverrides: {
				paper: {
					backgroundColor: COLORS.background,
					overflow: 'hidden',
					padding: '2rem 1rem',
					borderRadius: '0px 12px 12px 0px',
				},
			},
		},
		MuiTypography: {
			styleOverrides: {
				h4: {
					color: '#fff',
					fontWeight: 'bold',
				},
			},
		},
	},
})

const Sidebar = ({
	setOpenNotifications,
	countNotif,
	openNotifications,
	notificationButtonRef,
}) => {
	const dispatch = useAppDispatch()
	const location = useLocation()
	const permissions = useAppSelector(selectPermissions)

	const drawerStyles = useMemo(
		() => ({
			width: 230,
			flexShrink: 0,
			'& .MuiDrawer-paper': {
				zIndex: 1000,
				width: 230,
				boxSizing: 'border-box',
				height: '100vh',
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'space-between',
				borderRight: 'none',
				boxShadow: openNotifications ? COLORS.shadowSecondary : 'none',
				backgroundColor: COLORS.background,
				overflow: 'hidden',
				padding: '24px 12px',
				borderRadius: '0px 12px 12px 0px',
			},
		}),
		[openNotifications],
	)

	useEffect(() => {
		if (!permissions) {
			dispatch(fetchPermissions())
		}
	}, [])
	if (!permissions) return <></>
	return (
		<ThemeProvider theme={drawerTheme}>
			{location.pathname.includes('fill') ? (
				<Box sx={{ pt: '24px', pl: '40px' }}>
					<SmartFarmLogo fill={COLORS.main} />
				</Box>
			) : (
				<Drawer sx={drawerStyles} variant='permanent' anchor='left'>
					<Box
						display='flex'
						flexDirection='column'
						sx={{ flex: 1, minHeight: 0 }}
					>
						<NavLink to={'/feed'}>
							<SmartFarmLogo width={'100px'} fill={COLORS.main} />
						</NavLink>
						<SidebarMainMenu />
					</Box>

					<Box sx={{ pt: 2 }}>
						<SidebarSettings
							countNotif={countNotif}
							setOpenNotifications={setOpenNotifications}
							openNotifications={openNotifications}
							notificationButtonRef={notificationButtonRef}
						/>
					</Box>
				</Drawer>
			)}
		</ThemeProvider>
	)
}

export default Sidebar
